// 抛出mutations 突变
export const mutations = {
    // 定义突变状态模式
    MutationsState(state, data){
        // 定义生产模型类
        class ProductModel {
            // 构造函数
            constructor(state, data){

                // 初始（只执行一次 isTnit 方法）
                if(!state.initInfo.init){
                  this.isInit(state, data.axios, state.initInfo.line);
                }
                state.productInfo = JSON.parse(JSON.stringify(state.driveObj.driveA.productInfo));
                state.productInfoB = JSON.parse(JSON.stringify(state.driveObj.driveB.productInfo));


                // AB线
                this.line = state.initInfo.line;
                // 接收状态模式
                this.state = state;
                // console.log(state)
                // 接收数据点位对象
                this.Point = data.value;
                // 接收axios对象
                this.axios = data.axios;
            }


            // 定义出口
            Export(){
                // --------------------------片料机--------------------start
                this.Feed(  // A线
                      this.state.driveObj.driveA.feeder[0],    // 片料机
                      this.Point.A_A_Feed_run,    // A_A_Feed_run 片料机运行状态（1为运行，0为待机状态）
                      this.Point.A_A_Feed_alarm,  // A_A_Feed_alarm 片料机故障指示灯（1为故障）
                      this.Point.A_A_Feed_drop, // A_A_Feed_single 单张片料输入
                      this.Point.A_A_Feed_double, // A_A_Feed_double 双张片料输入
                      this.Point.A_A_Feed_lack,   // A_A_Feed_lack 片料机缺料报警（1为缺料）
                      this.Point.A_A_Feed_count   // A_A_Feed_count 片料机计数
                );
                this.Feed(  // B线
                      this.state.driveObj.driveB.feeder[0],    // 片料机  this.len==9
                      this.Point.B_B_Feed_run,    // B_B_Feed_run 片料机运行状态（1为运行，0为待机状态）
                      this.Point.B_B_Feed_alarm,  // B_B_Feed_alarm 片料机故障指示灯（1为故障）
                      this.Point.B_B_Feed_drop, // B_B_Feed_single 单张片料输入
                      this.Point.B_B_Feed_double, // B_B_Feed_double 双张片料输入
                      this.Point.B_B_Feed_lack,   // B_B_Feed_lack 片料机缺料报警（1为缺料）
                      this.Point.B_B_Feed_count   // B_B_Feed_count 片料机计数
                );
                // --------------------------片料机--------------------end

                // --------------------------拉伸机--------------------start
                this.Pull(                                // A线
                      this.state.driveObj.driveA.handcar[0],    // 拉伸机1
                      this.Point.A_A_Pull_originA1,     // 一拉油压机处于原点状态（1），0则为运行状态
                      this.Point.A_A_Pull_alarmA1,      // 异常故障
                      this.Point.A_A_Pull_lackA1,       // 缺料报警
                );
                this.Pull(                                // A线
                      this.state.driveObj.driveA.handcar[1],    // 拉伸机2
                      this.Point.M1_M1_Pull_originA2,     // 一拉油压机处于原点状态（1），0则为运行状态
                      this.Point.A_A_Pull_alarmA2,      // 异常故障
                      this.Point.A_A_Pull_lackA2,       // 缺料报警
                );
                this.Pull(                                // B线
                      this.state.driveObj.driveB.handcar[0],    // 拉伸机B1
                      this.Point.B_B_Pull_originB1,     // 一拉油压机处于原点状态（1），0则为运行状态
                      this.Point.B_B_Pull_alarmB1,      // 异常故障
                      this.Point.B_B_Pull_lackB1,       // 缺料报警
                );
                this.Pull(                                // B线
                      this.state.driveObj.driveB.handcar[1],    // 拉伸机B2
                      this.Point.K1_K1_Pull_originB2,     // 一拉油压机处于原点状态（1），0则为运行状态
                      this.Point.B_B_Pull_alarmB2,      // 异常故障
                      this.Point.B_B_Pull_lackB2,       // 缺料报警
                );
                // --------------------------拉伸机--------------------end

                // --------------------------冲床--------------------start
                this.Punch(                                // A线
                      this.state.driveObj.driveA.punch[0],    // 冲床1
                      this.Point.M2_M2_Punch_originA1,     // 一拉油压机处于原点状态（1），0则为运行状态
                );
                this.Punch(                                // A线
                      this.state.driveObj.driveA.punch[1],    // 冲床2
                      this.Point.M3_M3_Punch_originA2,     // 一拉油压机处于原点状态（1），0则为运行状态
                );
                this.Punch(                                // B线
                      this.state.driveObj.driveB.punch[0],    // 冲床B1
                      this.Point.K2_K2_Punch_originB1,     // 一拉油压机处于原点状态（1），0则为运行状态
                );
                this.Punch(                                // B线
                      this.state.driveObj.driveB.punch[1],    // 冲床B2
                      this.Point.K3_K3_Punch_originB2,     // 一拉油压机处于原点状态（1），0则为运行状态
                );
                // --------------------------冲床--------------------end

                // --------------------------机器人--------------------start
                this.Robot(  // A线
                        this.state.driveObj.driveA.robot[0],     // 机器人1
                        this.Point.M1_M1_sta,              // M1_M1_sta 机器人1的伺服状态 0停止1就绪2报警3运行
                        this.Point.M1_M1_count,            // M1_M1_count 机器人1计数 Int
                        this.Point.M1_M1_model,            // M1_M1_model 机器人作业文件编号 int
                );
                this.Robot(  // A线
                        this.state.driveObj.driveA.robot[1],     // 机器人2
                        this.Point.M2_M2_sta,              // M1_M1_sta 机器人1的伺服状态 0停止1就绪2报警3运行
                        this.Point.M2_M2_count,            // M1_M1_count 机器人1计数 Int
                        this.Point.M2_M2_model,            // M1_M1_model 机器人作业文件编号 int
                );
                this.Robot(  // A线
                        this.state.driveObj.driveA.robot[2],     // 机器人3
                        this.Point.M3_M3_sta,              // M1_M1_sta 机器人1的伺服状态 0停止1就绪2报警3运行
                        this.Point.M3_M3_count,            // M1_M1_count 机器人1计数 Int
                        this.Point.M3_M3_model,            // M1_M1_model 机器人作业文件编号 int
                );
                this.Robot(  // B线
                        this.state.driveObj.driveB.robot[0],     // 机器人1
                        this.Point.K1_K1_sta,              // K1_K1_sta 机器人1的伺服状态 0停止1就绪2报警3运行
                        this.Point.K1_K1_count,            // K1_K1_count 机器人1计数 Int
                        this.Point.K1_K1_model,            // K1_K1_model 机器人作业文件编号 int
                );
                this.Robot(  // B线
                        this.state.driveObj.driveB.robot[1],     // 机器人2
                        this.Point.K2_K2_sta,              // K2_K2_sta 机器人1的伺服状态 0停止1就绪2报警3运行
                        this.Point.K2_K2_count,            // K2_K2_count 机器人1计数 Int
                        this.Point.K2_K2_model,            // K2_K2_model 机器人作业文件编号 int
                );
                this.Robot(  // B线
                        this.state.driveObj.driveB.robot[2],     // 机器人3
                        this.Point.K3_K3_sta,              // K3_K3_sta 机器人1的伺服状态 0停止1就绪2报警3运行
                        this.Point.K3_K3_count,            // K3_K3_count 机器人1计数 Int
                        this.Point.K3_K3_model,            // K3_K3_model 机器人作业文件编号 int
                );
                // --------------------------机器人--------------------end
            }

            // 初始化
            isInit(obj, axios, line){
                obj.initInfo.init = true;
                // 初始化时间
                if(line=='B'){
                    obj.initInfo.initTime = localStorage.getItem('initTimeB') ? parseInt(localStorage.getItem('initTimeB')) : new Date().getTime(); // 初始化时间
                }
                else{
                    obj.initInfo.initTime = localStorage.getItem('initTime') ? parseInt(localStorage.getItem('initTime')) : new Date().getTime(); // 初始化时间
                }

                // 给A线每台设备添加属性
                ['feeder', 'handcar', 'punch', 'robot'].map((e , i) => {
                  obj.driveObj.driveA[e].map((d , j) => {
                    d['attr'] = JSON.parse(JSON.stringify(obj.device))
                  })
                });
                // 给B线每台设备添加属性
                ['feeder', 'handcar', 'punch', 'robot'].map((e , i) => {
                  obj.driveObj.driveB[e].map((d , j) => {
                    d['attr'] = JSON.parse(JSON.stringify(obj.device))
                  })
                });
                // console.log(obj.driveObj.driveA)
                // console.log(obj.driveObj.driveB)

            }


            // --------------------------片料机--------------------start
            // obj 设备对象
            // run 片料机运行状态（1为运行，0为待机状态）
            // alarm 片料机故障指示灯（1为故障）
            // single 单张片料输入
            // double 双张片料输入
            // lack 片料机缺料报警（1为缺料）
            // count 片料机计数
            Feed(obj, run, alarm, single, double, lack, count){
                // console.log(run, alarm, single, double, lack, count)
              if(run){
                obj.status = this.state.status.producting; // 生产中
                obj.color = 'green';
              }else{
                obj.status = this.state.status.productWait; // 待生产
                obj.color = 'orange';
              }
              // if(single || double){
              //   obj.status = this.state.status.warning; // 提示双片料
              //   obj.color = 'yellow';
              // }
              if(alarm || lack){
                obj.status = this.state.status.productStop; // 异常停机
                obj.color = 'red';
                obj.time = this.getDateTime('T');
              }
              if(count > parseInt(obj.attr.present)){
                obj.attr.present = count;  // 计数
              }
            }
            // --------------------------片料机--------------------end

            // --------------------------拉伸机--------------------start
            // origin  一拉油压机处于原点状态（1），0则为运行状态
            // alarm  异常故障
            // lack  缺料报警
            Pull(obj, origin, alarm, lack){
                // console.log(obj, origin, alarm, lack)
              if(parseInt(origin)===0){
                obj.status = this.state.status.producting; // 生产中
                obj.color = 'green';
              }else{
                obj.status = this.state.status.waiting; // 等待
                obj.color = 'orange';
              }
              if(alarm){
                obj.status = this.state.status.alarm; // 故障
                obj.color = 'red';
              }
              if(lack){
                obj.status = this.state.status.warning; // 报警
                obj.color = 'yellow';
              }
            }
            // --------------------------拉伸机--------------------end

            // --------------------------冲床--------------------start
            // origin  一拉油压机处于原点状态（1），0则为运行状态
            Punch(obj, origin){
                // console.log('===:', origin)
              if(Number(origin)===0){
                obj.status = this.state.status.producting;
                obj.color = 'green';
              }else{
                obj.status = this.state.status.waiting; // 等待
                obj.color = 'orange';
              }

            }
            // --------------------------冲床--------------------end

            // --------------------------机器人--------------------start
            // sta 机器人1的伺服状态 0停止1就绪2报警3运行
            // count 机器人1计数 Int
            // model 机器人作业文件编号 int
            Robot(obj,sta,count,model){
              if(obj.title === '2#'){
                // test-----------start
                // if(Math.random()*10>8){this.state.count += 1}
                // if(Math.random()*10>8){this.state.countB += 1}
                // if(obj.line==='A'){
                //     count = this.state.count;
                // }else{
                //     count = this.state.countB;
                // }

                // test ------------end

                this.productTime(obj, count); // 生产产能实际用时等
              }

              if(parseInt(sta) === 0){
                obj.status = this.state.status.runStop;  // 停止
                obj.color = 'yellow';
                // obj.load = 0;  // 停止时间
                // obj.up = 0; // 稼动时间结束
              }else if(parseInt(sta) === 1){
                obj.status = this.state.status.runByIn;  // 就绪
                obj.color = 'white';
                // obj.load += 1;  // 负荷时间
                // obj.up = 0; // 稼动时间结束
              }else if(parseInt(sta) === 2){
                obj.status = this.state.status.alarm;  // 故障
                obj.color = 'red';
                obj.time = this.getDateTime('T'); // 时间
                // obj.up = 0; // 稼动时间结束
                // obj.load += 1;  // 负荷时间
              }else if(parseInt(sta) === 3){
                // this.dataState(obj,1);
                obj.status = this.state.status.run;  // 运行
                obj.color = 'green';
                // obj.up += 1; // 稼动时间开始
                // obj.load += 1;  // 负荷时间
              }else{}
              if(parseInt(sta) !== 3){
                // this.dataState(obj,0);
              }

              // if(this.stopTime && this.stopTime > 0){
              //   let s = parseInt((new Date().getTime() - this.stopTime) / 1000); // 停机时间
              // }

              // if(count > parseInt(obj.present)){
              //   obj.present = count;  // 计数
              //   // this.RenderData(obj);  // 数据渲染
              //   obj.up = 0; // 稼动时间结束
              //   if(obj.deviceNum === 4 && parseInt(obj.yield)>0){
              //     let rate = parseInt(count/parseInt(obj.yield) *100);
              //     // this.activation.series[6].data[0].value = rate; // 生产进度
              //     // this.activation.series[6].data[1].value = 100 - rate; // 生产进度
              //     // this.activation.series[6].data[0].name = `${rate}%`; // 生产进度
              //     let item = {}; // 定义对象
              //     item.state = ''
              //     this.RenderData(obj);  // 数据渲染
              //   }
              // }

              // this.addLoadUpTime(obj); // 计算负荷与稼动时间

              // if(parseInt(obj.loadS) > 0){
              //   obj.rate = parseInt(obj.upS/obj.loadS * 100) // 时间稼动率
              //   if(obj.rate>100){obj.rate = 100}
              //   // this.activation.series[obj.deviceNum/2-1].data[0].value = parseInt(obj.rate); // 给echart视图赋值
              //   // this.activation.series[obj.deviceNum/2-1].data[1].value = (100 - parseInt(obj.rate)); // 给echart视图赋值
              //   // this.activation.series[obj.deviceNum/2-1].data[0].name = `${parseInt(obj.rate)}%`; // 给echart视图赋值
              //   // this.EfficencyEcharts(); // 稼动率（视图）
              // }
              // if(model){
              //   obj.odd = model;  // 机器人作业编号
              // }
            }
            // --------------------------机器人--------------------end

            // 数据渲染
            RenderData(obj){
              obj.date = this.getDateTime('T'); // D日期，T时间，其他默认
              obj.schedule = (obj.present/parseInt(obj.yield)*100).toFixed(0)+'%'; // 进度
              if(this.line===0){
                this.statement.unshift(obj)
              }else{
                this.statementB.unshift(obj);  // 插入数组
              }

            }

            //  稼动率
            // EfficencyEcharts() {
            //   this.efficency = this.$echarts.init(this.$refs.efficency);
            //   this.efficency.setOption(this.activation);
            // },
            // //  状态
            // StateEcharts() {
            //   this.stateEchart = this.$echarts.init(this.$refs.echarts1);
            //   this.stateEchart.setOption(this.option1);
            // },

            // 计算负荷与稼动时间
            addLoadUpTime(obj){
              if(obj.load === 1){
                obj.loadtime = new Date().getTime();  // 赋值时间
              }
              if(obj.up === 1){
                obj.uptime = new Date().getTime();  // 稼动时间
              }
              if(obj.load){ // 判断是否为负荷时间
                obj.loadS = parseInt((new Date().getTime() - obj.loadtime) / 1000); // 负荷时间
              }
              if(obj.up){ // 判断是否为稼动时间
                obj.upS = parseInt((new Date().getTime() - obj.uptime) / 1000); // 计算稼动时间
              }
            }

            // 生产产能实际用时等
            productTime(obj, count){
                // let seconds = 60*60; // 60秒
                let seconds = 60; // 60秒
                if(count > obj.attr.cout){
                    obj.attr.cout = count;
                    if(obj.attr.out<1){obj.attr.out = Number(localStorage.getItem(`Out${obj.line}`)) || 0;}
                    obj.attr.out += 1;
                    // 保存产量
                    localStorage.setItem(`Out${obj.line}`, obj.attr.out);
                }
              if(parseInt(obj.attr.second) === 0){ // 开始计算时间
                obj.attr.time = new Date().getTime();
                obj.attr.out = 0;
                localStorage.setItem(`Out${obj.line}`, obj.attr.out);
              }
              if(parseInt((new Date().getTime() - Number(obj.attr.time)) /1000) >= seconds){ // 计算实际用时
                // obj.attr.reality = parseInt(obj.doneTH) + parseInt((new Date().getTime() - parseInt(obj.attr.time)) /1000);
                // this.saveDoneTime({name: obj.doneTHName, value: obj.doneTH});
                // this.getDoneTime().then(res => {
                //   let val = res.attr.list[0].value;
                //   !val ? val = 0: val;
                //   obj.doneTH = parseInt(val);
                // });
                obj.attr.second = seconds;
              }else{ // 赋值时间
                obj.attr.second = parseInt((new Date().getTime() - Number(obj.attr.time)) /1000) <= 0 ? 1: parseInt((new Date().getTime() - Number(obj.attr.time)) /1000);
              }
              if(obj.attr.second === seconds){
                obj.attr.second = 0;  // 清零时间
                // 计算产能及计划产量
                this.capacityYield(this.state.driveObj[`drive${obj.line}`], obj, count);
                obj.attr.predict = obj.attr.capacity > 0 ? Number((obj.attr.product/obj.attr.capacity).toFixed(1)) : 0; // 预计完成时间
                obj.attr.predict < 0 ? obj.attr.predict = 0 : null;
                // obj.attr.out = count; // 重新赋值
                // 给实时生产状态赋值
                this.renderProductState(this.state.driveObj[`drive${obj.line}`], obj);
              }else{
                obj.attr.yield = Number(this.state.driveObj[`drive${obj.line}`].productInfo.output);
                obj.attr.product = obj.attr.yield - count;
                this.getCapacity(obj);
                this.state.driveObj[`drive${obj.line}`].productInfo.doneTime = Number(localStorage.getItem(`doneTime${obj.line}`)) || 0; // 预计完成时间（分钟）
              }
            }

            // 读取localStorage数据
            getCapacity(obj){
              obj.attr.capacity = localStorage.getItem(`capacity${obj.line}`) ? localStorage.getItem(`capacity${obj.line}`) : 0; // 每分钟生产个数
              this.renderProductState(this.state.driveObj[`drive${obj.line}`], obj); // 给实时生产状态赋值
            }

            // 计算产能及计划产量
            capacityYield(prod, obj, count){
              obj.attr.yield = Number(prod.productInfo.output); // 计划产量
              obj.attr.product = obj.attr.yield - count;
              // obj.attr.capacity = count - obj.attr.out; // 每小时生产个数
              obj.attr.capacity = obj.attr.out; // 每小时生产个数
              // localStorage.setItem(`capacity${obj.line}`, count - obj.attr.out);
              localStorage.setItem(`capacity${obj.line}`, obj.attr.out);
            }

            // 给实时生产状态赋值
            renderProductState(prod, obj){
              prod.productInfo.doneProduct = obj.attr.yield - obj.attr.product; // 当前完成的产量
              prod.productInfo.product = obj.attr.product; // 剩余产量
              prod.productInfo.products = obj.attr.capacity; // 产能
              prod.productInfo.doneTime = obj.attr.predict; // 预计完成时间（分钟）
              obj.attr.predict > 0 ? localStorage.setItem(`doneTime${obj.line}`, obj.attr.predict): null; // 预计完成时间（分钟）
              prod.productInfo.progress = Number((((obj.attr.yield - obj.attr.product) / obj.attr.yield) * 100).toFixed(0)); // 当前进度
            }


            // -----------------------公共方法----------------start
            // 获取时间日期
            getDateTime(t){
              var now = new Date();
              let Y = now.getFullYear();
              let M = now.getMonth() + 1;
              let D = now.getDate();
              let h = now.getHours();
              let m = now.getMinutes();
              let s = now.getSeconds();
              M = M < 10 ? `0${M}`: M;
              D = D < 10 ? `0${D}`: D;
              h = h < 10 ? `0${h}`: h;
              m = m < 10 ? `0${m}`: m;
              s = s < 10 ? `0${s}`: s;
              var timeStr = '';
              switch (t) {
                case t === 'time' || 'T' || 'Time':
                  timeStr = `${h}:${m}:${s}`;
                  break;
                case t === 'date' || 'D' || 'Date':
                  timeStr = `${Y}-${M}-${D}`;
                  break;
                default:
                  return `${Y}-${M}-${D} ${h}:${m}:${s}`;
              }
              return timeStr;
            }

            // -----------------------公共方法----------------end



            // ----------------内层方法----------------end

            // --------------------------------请求地址----------------start
            async saveDoneTime(data){  // 保存实际用时
              let { data: res } = await this.axios.put(`/savetime`, data);
              return res
            }

            async getDoneTime(){  // 获取实际时间
              let { data: res } = await this.axios.get("/savetime");
              return res
            }






            // --------------------------------请求地址----------------end


            dataState(obj, v) {
              this.option1.series[obj.deviceNum].data.pop;
              this.option1.series[obj.deviceNum].data.unshift(5*v+obj.deviceNum*10+10);
              // this.StateEcharts();
            }
        }
        // 实例化生产模型对象
        let proObj = new ProductModel(state, data);
        // 调用出口
        proObj.Export();
    }
}